import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Chip,
  Dialog,
  DialogContent,
  IconButton,
  InputAdornment,
  Paper,
  Stack,
  TextField,
} from "@mui/material";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";

const EXAMPLE_PROMPTS = [
  "Data engineers with BigQuery and Airflow under $35/hr",
  "Analytics engineers with Looker and SQL",
  "Platform engineers with Terraform and GCP",
  "Contractors for finance data pipelines",
];

const DashboardSearchPalette = ({ open, onClose, role = "" }) => {
  const history = useHistory();
  const [query, setQuery] = useState("");

  const handleSubmit = (nextQuery = query) => {
    const value = String(nextQuery || "").trim();
    if (value.length < 3) return;
    setQuery(value);
    onClose();
    const basePath = role === "admin" ? "/admin/dashboard/search" : "/client/dashboard/search";
    history.push(`${basePath}?q=${encodeURIComponent(value)}`);
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: 2.5,
          overflow: "hidden",
          boxShadow: "0 20px 56px rgba(60,64,67,0.28)",
          mt: { xs: 0, sm: "-18vh" },
        },
      }}
    >
      <DialogContent sx={{ p: 0, bgcolor: "#fbfcfd" }}>
        <Stack spacing={1.5}>
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 1.25, sm: 1.5 },
              borderRadius: 2,
              borderColor: "#dadce0",
              borderTop: "4px solid #1976d2",
            }}
          >
            <Stack spacing={1.5}>
              <TextField
                autoFocus
                fullWidth
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    handleSubmit();
                  }
                }}
                placeholder='Data engineers with BigQuery and Airflow under $35/hr'
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AutoAwesomeOutlinedIcon color="primary" />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Search contractors"
                        disabled={query.trim().length < 3}
                        onClick={() => handleSubmit()}
                        sx={{ color: "primary.main" }}
                      >
                        <SearchOutlinedIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                {EXAMPLE_PROMPTS.map((prompt) => (
                  <Chip
                    key={prompt}
                    label={prompt}
                    clickable
                    onClick={() => handleSubmit(prompt)}
                    sx={{ borderRadius: 1.5, bgcolor: "#fff" }}
                  />
                ))}
              </Stack>
            </Stack>
          </Paper>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default DashboardSearchPalette;
